import { P, Predicate } from "breadcommon";

export interface TransactionColumnFilterDisplayRuleProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayRule({
  predicate,
}: TransactionColumnFilterDisplayRuleProps): JSX.Element {
  // Parse the predicate to extract the search text and match type
  // Expected structure: P.SubstringCI(P.Field("rule"), P.Literal(string)) or P.EqualsCI(...)
  const serializable = predicate.asSerializable();

  if (
    (serializable.name === P.OpName.SubstringCI ||
      serializable.name === P.OpName.EqualsCI) &&
    serializable.args.length === 2
  ) {
    const literalOp = serializable.args[1];
    if (literalOp.name === P.OpName.Literal) {
      const searchText = literalOp.args[0];
      if (typeof searchText === "string") {
        const isExact = serializable.name === P.OpName.EqualsCI;
        return (
          <span>
            Rule {isExact ? "is" : "contains"} "{searchText}"
          </span>
        );
      }
    }
  }

  // Fallback if predicate structure is unexpected
  return <span>Rule filter</span>;
}
